<script>
	import Form from "./Form.svelte"
</script>
<style>
	.ContentForm{
		background-color: var(--principal);
		text-align: center;
		padding: 6rem 0 7rem;
	}
	.ContentForm *{
		color: #fff;
	}
	.ContentForm--title{
		font-weight: 900;
		font-size: 2.5rem;
		margin-bottom: 1.5rem;
	}
	.ContentForm--paragraph{
		font-size: 1rem;
		line-height: 1;
		width: 50%;
		margin: 0 auto;
		margin-bottom: 4rem;
		font-weight: 400;
	}
</style>
<div class="ContentForm" id="cotization">
	<h3 class="ContentForm--title">
		Solicita tu cotización
	</h3>
	<p class="ContentForm--paragraph">
		Contactame, haremos grandes cosas juntos.
	</p>
	<Form />
</div>